const getPrescriberLastName = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber['Last Name']) {
    return prescriber['Last Name'].toUpperCase();
  }
  if (patient.Prescriber[0]) {
    return patient.Prescriber[0]['Last Name'].toUpperCase();
  }
  return null;
};

export default getPrescriberLastName;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberLastName.js